import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-day-notes',
  templateUrl: './dailyNotes.component.html',
  styleUrls: ['./dailyNotes.component.scss']
})
export class DailyNotesComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DailyNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      console.log(data)
    }


  ngOnInit(): void {

  }

  getDate(date: any): string{
    var d = new Date(date);
    return d.getDate() + "." + (d.getMonth()+1) + "." + d.getFullYear()
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

}
